<div class="modal-body confirm-pass">


    <button (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
    <h2 class="heading">Enter password</h2>
    <p>Please enter your password to proceed</p>

    <mat-form-field class="example-full-width">
        <input type="password" matInput placeholder="Password" [(ngModel)]="password">

    </mat-form-field>
    <label *ngIf="submitted && password==null" style="color: red;">
        password is required
    </label>
    <button type="button" class="primary-btn" (click)="done()">
        SUBMIT
    </button>
</div>